<div id="temperature-display-container" class="custom_ui">
  <div class="energyToolWidgetTitle" id="temperature-display-title">
    {{ "energy_tool.temperature_display.current_temperature" | translate }}
  </div>

  @if (timeOut()) {
    <app-timeout></app-timeout>
  } @else if (loading()) {
    <p-progressSpinner ariaLabel="loading" class="customProgressSpinner" />
  } @else if (noData()) {
    <span class="noData">
      {{ "common.no_data" | translate }}
    </span>
  } @else {
    <div id="temperature-container">
      <div class="temperature-kpi">
        <span>{{ outsideTemperatureDisplay() }}</span>
        <span>ºC</span>
        <span>{{ "energy_tool.temperature_display.outside" | translate }}</span>
      </div>
      <div class="temperature-kpi">
        <span>{{ delta() !== null ? delta() : "-" }}</span>
        <span>ºC</span>
        <span>{{ "energy_tool.temperature_display.delta" | translate }}</span>
      </div>
      <div class="temperature-kpi">
        <span>{{ insideTemperatureDisplay() }}</span>
        <span>ºC</span>
        <span>{{ "energy_tool.temperature_display.inside" | translate }}</span>
      </div>
    </div>
  }
</div>
